import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Grid, Input, Modal, Panel, DatePicker, 
} from 'framework-ui-components';
import { Button } from 'framework-ui-components/Components/V2';
import { SnackbarWrapper } from 'framework-ui-components/Components/Snackbar';
import { codiceFiscaleValido } from 'framework-ui-components/Components/Validation';
import { StatoDichiarazione } from '../../enums';
import * as webapi from '../../apis/assegnoNucleoFamiliareApi';
import { cercaAnagraficaInUfficio } from '../../apis/anagraficaApi';
import { 
  validaDataInizioValidita, validaDataFineValidita, isDataInizioValiditaValida, isDataFineValiditaValida,
} from './helpersDate';

const lableCrea = 'Crea';

class ModaleCreazioneOrdinario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commit: {
        label: lableCrea,
      },
      codiceFiscale: '',
      cognome: '',
      nome: '',
      dataInizio: `${props.annoCampagna}-07-01T00:00:00.000Z`,
      dataFine: `${props.annoCampagna + 1}-06-30T00:00:00.000Z`,
      idAnagrafica: null,
      minDataCanonica: `${props.annoCampagna}-07-01T00:00:00.000Z`,
      maxDataCanonica: `${props.annoCampagna + 1}-06-30T00:00:00.000Z`,
        esitoCreabilitaImpostato: false, // flag che indica se l'esito di creazione è stato impostato dalla funzione apposita
        conteggioSovrapposte: 0,
    };
  }

  componentDidUpdate(propsPrecedenti, statePrecedente, snapshot) {
    const { codiceUfficio, annoCampagna } = this.props;
    const {
      codiceFiscale, dataInizio, dataFine, cognome, idAnagrafica, esitoCreabilitaImpostato,
    } = this.state;

    const isCodiceFiscaleValido = codiceFiscale && codiceFiscaleValido(codiceFiscale);

    // se è stato modificato il codice fiscale e il codice è formalmente corretto
    // allora prova a decodificare l'anagrafica
    if (isCodiceFiscaleValido && codiceFiscale != statePrecedente.codiceFiscale) {
      this.aggiornaAnagrafica(codiceFiscale, codiceUfficio);
    } else if (cognome && (!codiceFiscale || !isCodiceFiscaleValido)) {
      // se non ci sono le condizioni per valutare l'anagrafica
      // ma il cognome è già valorizzato, allora lo pulisce
        this.pulisciAnagrafica();
        return;
    }

    // se i dati necessari per controllare la possibilità di creazione
    // sono stati inseriti e variati rispetto a prima...
    if (codiceFiscale && dataInizio && dataFine
      && (codiceFiscale != statePrecedente.codiceFiscale
        || dataInizio != statePrecedente.dataInizio
        || dataFine != statePrecedente.dataFine
        || idAnagrafica != statePrecedente.idAnagrafica)) {
      if (this.isDatiPerCreazioneValidi()) {
        // i dati sono corretti, verifica se la dichiarazione è creabile/modificabile
        this.verificaDichiarazioneCreabile(codiceFiscale, codiceUfficio, annoCampagna, dataInizio, dataFine);
      } else if (esitoCreabilitaImpostato) {
        // i dati base sono cambiati ma sono errati: pulisce l'eventuale
        // popolamento precedente
        this.pulisciEsitoVerificaDichiarazioneCreabile();
      }
    }
  }

  // controlla che i dati necessari per la chiamata alla verifica creazione
  // siano disponibili e formalmente corretti
  // (non tutti i dati testati da formValido sono necessari per il
  // controllo dichiarazione creabile)
  isDatiPerCreazioneValidi() {
    const {
      codiceFiscale, dataInizio, dataFine, minDataCanonica, maxDataCanonica,
    } = this.state;

    if (!(codiceFiscale && codiceFiscaleValido(codiceFiscale))) {
      return false;
    }

    if (!isDataInizioValiditaValida(minDataCanonica, maxDataCanonica, dataInizio)) {
      return false;
    }

    if (!isDataFineValiditaValida(minDataCanonica, maxDataCanonica, dataInizio, dataFine)) {
      return false;
    }

    return true;
  }

  // resetta gli effetti di una chiamata a "verificaDichiarazioneCreabile"
  pulisciEsitoVerificaDichiarazioneCreabile() {
    this.setState({
      messaggi: [],
      creabile: false,
      modificabile: false,
      esisteReiezione: false,
      commit: {
        disabled: true,
        label: lableCrea,
      },
        esitoCreabilitaImpostato: false,
      conteggioSovrapposte: 0,
    });
  }

  // se il cf esiste già in anagrafica, recupera i dati anagrafici
  aggiornaAnagrafica(codiceFiscale = '', codiceUfficio) {
    cercaAnagraficaInUfficio(codiceFiscale, codiceUfficio)
      .then((res) => {
        if (res) {
          this.setState({
            idAnagrafica: res.IdAnagrafica,
            cognome: res.Cognome,
            nome: res.Nome,
          });
        } else {
          this.pulisciAnagrafica();
        }
      })
      .catch((ex) => {
        this.pulisciAnagrafica();
      });
  }

  // resetta gli efftti del recupero dati anagrafici
  pulisciAnagrafica() {
    this.setState({
      idAnagrafica: null,
      cognome: null,
      nome: null,
    });
  }

  // chiede al server se con i parametri attuali
  // è possibile creare una dichiarazione
    verificaDichiarazioneCreabile(codiceFiscale = '', codiceUfficio, anno, dataInizio, dataFine) {
    this.setState({ working: true });
        webapi.verificaOrdinarioCreabile({ codiceFiscale, codiceUfficio, anno, dataInizio, dataFine })
      .then(result => this.elaboraRispostaVerificaCreabilita(result || {}))
      .catch((ex) => {
        SnackbarWrapper.notifyError(ex.message);
        this.setState({ working: false });
      });
  }

  // esegue il comando attivo nella modale: crea, visualizza, modifica
  avviaComando() {
    const {
      idAssegnoNucleoFamiliare, creabile, modificabile, stato, esisteReiezione, conteggioSovrapposte,
    } = this.state;
    const {
      apriDichiarazione, chiudi, creaDichiarazioneOrdinaria,
    } = this.props;

    if (esisteReiezione) {
      return chiudi();
      }

      if (conteggioSovrapposte > 1) {
          return chiudi();
      }

    if (creabile) {
      creaDichiarazioneOrdinaria(this.state)
        .then((res) => {
          if (res.Success) {
            apriDichiarazione(res.Response.IdAssegnoNucleoFamiliare, true);
          } else {
            this.setState({ messaggi: res.DetectedProblems, working: false });
          }
        })
        .catch(ex => this.setState({ messaggi: [ex.message], working: false }));
    } else {
      apriDichiarazione(idAssegnoNucleoFamiliare, modificabile && stato == StatoDichiarazione.InLavorazione);
    }
  }

  // gestisce il risultato della chiamata per sapere
  // se è possibile creare la dichiarazione
  elaboraRispostaVerificaCreabilita({ DetectedProblems, Response }) {
    const { cognome, nome } = this.state;

    if (!Response) {
      // errore di comunicazione
      this.setState({
        messaggi: DetectedProblems,
        creabile: false,
        codiceFiscale: null,
        working: false,
      });
    } else {
      if (DetectedProblems.length == 0) {
        // se non ci sono errori ed esiste già una dichiarazione, gestisce la richiesta di modifica/visualizzazione
          if (Response.Modificabile || Response.IdAssegnoNucleoFamiliare) {
              // const descrizioneStato = Response.Stato == StatoDichiarazione.InLavorazione && Response.TotaleErrori > 0 ? 'Errata' : StatoDichiarazione.stringify(Response.Stato);
              // DetectedProblems.push(`Esiste una dichiarazione per ${cognome} ${nome} in stato "${descrizioneStato}". Vuoi ${(Response.Modificabile && Response.Stato == StatoDichiarazione.InLavorazione) ? 'modificarla' : 'visualizzarla'} ?`);
              DetectedProblems.push(`Esiste una richiesta ANF con periodo di validità sovrapposto, vuoi ${(Response.Modificabile && Response.Stato == StatoDichiarazione.InLavorazione) ? 'modificarla' : 'visualizzarla'} ?`);
          } else if (Response.ConteggioSovrapposte > 1) {
              DetectedProblems.push(`Esiste più di una richiesta ANF con periodo di validità sovrapposto: modifica il periodo di validità inserito oppure quello delle richieste già esistenti, se modificabili.`);
          } else if (!Response.Creabile && !Response.EsisteReiezione) {
              DetectedProblems.push(`Non è possibile creare una dichiarazione per ${cognome} ${nome}`);
          }
      }
      // riporta nello stato l'esito fornito dal server
      this.setState({
        idAnagrafica: Response.IdAnagrafica,
        // cognome: Response.Cognome,
        // nome: Response.Nome,
        esisteReiezione: Response.EsisteReiezione,
        messaggi: DetectedProblems,
        creabile: Response.Creabile,
        modificabile: Response.Modificabile,
        stato: Response.Stato,
        totaleErrori: Response.TotaleErrori,
        idAssegnoNucleoFamiliare: Response.IdAssegnoNucleoFamiliare,
        commit: {
          disabled: !Response.Creabile && !Response.Modificabile && !Response.IdAssegnoNucleoFamiliare,
          label: (Response.Modificabile && Response.Stato == StatoDichiarazione.InLavorazione) ? 'Modifica'
            : (Response.IdAssegnoNucleoFamiliare ? 'Visualizza'
              : (Response.EsisteReiezione || Response.ConteggioSovrapposte > 0 ? 'Ho Capito' : lableCrea)),
        },
        working: false,
          esitoCreabilitaImpostato: true,
          conteggioSovrapposte: Response.ConteggioSovrapposte,
      });
    }
  }

  handleFormChange(x) {
    this.setState(x);
  }

  handleClickCrea() {
    // forza una chiamata alla validazione form
    // per assicurarsi che le date (e gli altri campi) siano validi
    // prima di procedere con il crea
    if (this.form.valida()) {
      if (this.formValido()) {
        this.setState({ working: true });
        this.avviaComando();
      }
    }
  }

  formValido() {
    const { FormErrors } = this.state;
    return !(Object.values(FormErrors).some(ff => ff && ff.length > 0));
  }

  render() {
    const { annoCampagna, chiudi } = this.props;
    const {
      messaggi, working, idAnagrafica, commit, esisteReiezione, 
      dataInizio,
      dataFine,
      codiceFiscale,
      cognome,
      nome,
      minDataCanonica,
        maxDataCanonica,
      conteggioSovrapposte,
    } = this.state;

    const disabilitatoCrea = (!codiceFiscaleValido(codiceFiscale) || !cognome || !nome || !this.formValido());
    return (
      <Modal show onClose={() => chiudi()} loading={working}>
        <Modal.Header>
          Crea Assegno nucleo familiare ordinario {annoCampagna}
        </Modal.Header>
        <Modal.Body>
          <Form onChange={x => this.handleFormChange(x)} stato={this.state} ref={r => this.form = r}>
            <Grid fluid>
              <Grid.Row>
                <Grid.Col md="6">
                                <DatePicker name="dataInizio" title="Inizio validità" futureDate validations={validaDataInizioValidita(minDataCanonica, maxDataCanonica, dataInizio)} />
                </Grid.Col>
                <Grid.Col md="6">
                                <DatePicker name="dataFine" title="Fine validità" futureDate validations={validaDataFineValidita(minDataCanonica, maxDataCanonica, dataInizio, dataFine)} />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="6">
                  <Input title="Codice fiscale" name="codiceFiscale" validations={['required', 'CodiceFiscaleAlfaNumerico']} maxLength="16" upperCase />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="6">
                  <Input title="Cognome" name="cognome" validations={['required']} disabled={idAnagrafica} upperCase />
                </Grid.Col>
                <Grid.Col md="6">
                  <Input title="Nome" name="nome" validations={['required']} disabled={idAnagrafica} upperCase />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="12">
                  {
                                    esisteReiezione && conteggioSovrapposte == 1 && (
                                        <Panel alert> Esiste già una richiesta ANF in stato &quot;Reiezione INPS&quot; con periodo di validità sovrapposto.<br />
                                            Per generare una nuova richiesta utilizza la funzione &quot;Duplica in un nuovo Anf&quot;, presente nel menu del rigo della richiesta esistente.
                    </Panel>
                    )
                  }
                  {
                    messaggi && messaggi.length == 1 && (
                      <Panel error>
                        {messaggi[0]}
                      </Panel>
                    )
                  }
                  {
                    messaggi && messaggi.length == 2 && (
                      <Panel error>
                        {messaggi[0]}<br />{messaggi[1]}
                      </Panel>
                    )
                  }

                  {
                    messaggi && messaggi.length == 3 && (
                      <Panel error>
                        {messaggi[0]}<br />{messaggi[1]}<br />{messaggi[2]}
                      </Panel>
                    )
                  }

                  {
                    messaggi && messaggi.length > 3 && (
                      <Panel error>
                        {messaggi[0]}<br />{messaggi[1]}<br />{messaggi[2]}<br />{messaggi[4]}
                      </Panel>
                    )
                  }
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button emphasis={Button.Emphasis.HIGH} onClick={() => chiudi()}>Annulla</Button>
          <Button emphasis={Button.Emphasis.HIGH} primary disabled={disabilitatoCrea} onClick={() => this.handleClickCrea()}>{commit.label}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleCreazioneOrdinario.propTypes = {
  annoCampagna: PropTypes.number.isRequired,
  codiceUfficio: PropTypes.string.isRequired,
  chiudi: PropTypes.func.isRequired,
  apriDichiarazione: PropTypes.func.isRequired,
  creaDichiarazioneOrdinaria: PropTypes.func.isRequired,
};

export default ModaleCreazioneOrdinario;
